var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.605 11.94a.05.05 0 0 1 .07.056l-.707 2.835a1.45 1.45 0 0 0 2.055 1.65l.047-.025a.7.7 0 1 0-.638-1.246l-.037.019a.05.05 0 0 1-.07-.058l.71-2.837a1.45 1.45 0 0 0-2.053-1.649l-.038.02a.7.7 0 1 0 .614 1.257l.04-.02zM12.907 8.333a.9.9 0 1 0-1.8 0v.008a.9.9 0 0 0 1.8 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 2.383a9.7 9.7 0 1 0 0 19.4 9.7 9.7 0 0 0 0-19.4M6.133 6.214A8.3 8.3 0 1 1 17.87 17.952 8.3 8.3 0 0 1 6.132 6.214",
  clipRule: "evenodd"
})));
export default SvgInfoCircle;